/* =========================================================
   WWC Manual City Bubbles
   Requires Swiper loaded globally in theme.liquid
========================================================= */

(function () {
  'use strict';

  var ROOT_SELECTOR = '[data-wwc-manual-bubbles]';

  function toBool(value) {
    return value === true || value === 'true' || value === '1';
  }

  function toNumber(value, fallback) {
    var parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function waitForSwiper(callback) {
    if (window.Swiper) {
      callback();
      return;
    }

    var tries = 0;
    var timer = window.setInterval(function () {
      tries += 1;

      if (window.Swiper) {
        window.clearInterval(timer);
        callback();
      }

      if (tries > 80) {
        window.clearInterval(timer);
      }
    }, 50);
  }

  function getInitialIndex(root, slides) {
    var startIndex = toNumber(root.dataset.startIndex, 0);
    var startOnActive = toBool(root.dataset.startOnActive);

    if (startOnActive) {
      var activeIndex = slides.findIndex(function (slide) {
        return slide.dataset.active === '1';
      });

      if (activeIndex >= 0) {
        startIndex = activeIndex;
      }
    }

    if (startIndex < 0 || startIndex >= slides.length) {
      startIndex = 0;
    }

    return startIndex;
  }

  function initBubbles(root) {
    if (!root || root.dataset.wwcBubblesReady === '1') return;

    root.dataset.wwcBubblesReady = '1';

    var slider = root.querySelector('[data-wwc-bubbles-slider]');
    var track = root.querySelector('[data-wwc-bubbles-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('.swiper-slide'));

    if (!slider || !track || !slides.length) return;

    var showNav = toBool(root.dataset.showNav);
    var showScrollbar = toBool(root.dataset.showScrollbar);
    var mobileSingleCard = toBool(root.dataset.mobileSingleCard);
    var greyUnreachable = toBool(root.dataset.greyUnreachable);
    var hideNavWhenUnneeded = toBool(root.dataset.hideNavWhenUnneeded);

    var buttonsWrap = root.querySelector('[data-wwc-bubbles-buttons]');
    var btnPrev = root.querySelector('.wwc-bubbles__button--prev');
    var btnNext = root.querySelector('.wwc-bubbles__button--next');
    var scrollbar = root.querySelector('[data-wwc-bubbles-scrollbar]');

    var mediaMobile = window.matchMedia('(max-width: 749px)');
    var isMobile = mediaMobile.matches;
    var oneCardMobile = mobileSingleCard && isMobile;
    var initialIndex = getInitialIndex(root, slides);

    function fitsCompletely() {
      return track.scrollWidth <= slider.clientWidth + 1;
    }

    function setDisabled(button, state) {
      if (!button) return;

      button.classList.toggle('is-disabled', state && greyUnreachable);
      button.setAttribute('aria-disabled', state ? 'true' : 'false');
    }

    function updateNavState(swiper) {
      if (!showNav || !btnPrev || !btnNext || !buttonsWrap) return;

      var noScroll = fitsCompletely();

      if (hideNavWhenUnneeded) {
        buttonsWrap.style.display = noScroll ? 'none' : '';
      }

      if (noScroll) {
        setDisabled(btnPrev, true);
        setDisabled(btnNext, true);
        return;
      }

      setDisabled(btnPrev, swiper.isBeginning);
      setDisabled(btnNext, swiper.isEnd);
    }

    waitForSwiper(function () {
      var swiper = new window.Swiper(slider, {
        speed: 300,
        initialSlide: initialIndex,
        slidesPerView: oneCardMobile ? 1 : 'auto',
        centeredSlides: oneCardMobile,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        resizeObserver: true,
        navigation: showNav && btnNext && btnPrev ? {
          nextEl: btnNext,
          prevEl: btnPrev
        } : false,
        scrollbar: showScrollbar && scrollbar ? {
          el: scrollbar,
          draggable: true
        } : false
      });

      track.classList.add('is-ready');
      slider.setAttribute('aria-busy', 'false');

      function refresh() {
        swiper.update();
        updateNavState(swiper);
      }

      window.requestAnimationFrame(function () {
        swiper.slideTo(initialIndex, 0, false);
        refresh();
      });

      swiper.on('slideChange', function () {
        updateNavState(swiper);
      });

      swiper.on('resize', refresh);
      swiper.on('observerUpdate', refresh);

      window.addEventListener('resize', refresh, { passive: true });

      var images = root.querySelectorAll('img');
      images.forEach(function (image) {
        if (image.complete) return;
        image.addEventListener('load', refresh, { once: true });
        image.addEventListener('error', refresh, { once: true });
      });

      if (window.Shopify && window.Shopify.designMode) {
        document.addEventListener('shopify:section:load', function (event) {
          if (event.target && event.target.contains(root)) {
            refresh();
          }
        });
      }
    });
  }

  function initAllBubbles() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(initBubbles);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllBubbles);
  } else {
    initAllBubbles();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target) return;

    var roots = event.target.matches && event.target.matches(ROOT_SELECTOR)
      ? [event.target]
      : Array.prototype.slice.call(event.target.querySelectorAll(ROOT_SELECTOR));

    roots.forEach(initBubbles);
  });
})();

/* ==================================================
   WWC Collection Clean
   JS: assets/collection JS
================================================== */

(function () {
  var section = document.querySelector('[data-wwc-collection-clean]');
  if (!section) return;
  if (section.dataset.wwcCollectionInited === '1') return;

  section.dataset.wwcCollectionInited = '1';

  var ajaxLock = false;
  var ajaxTimer = null;
  var cityIndex = [];
  var cityIndexLoaded = false;
  var cityIndexPromise = null;
  var productTypeFilterKey = 'filter.p.product_type';
  var scrollActiveProductTypeAfterAjax = false;

  var loadingText = section.dataset.wwcLoadingText || 'Loading...';
  var loadMoreText = section.dataset.wwcLoadMoreText || 'Load more';

  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }

  function qsa(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function normalize(value) {
    return String(value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/['’`”"]/g, '')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function isMaterialFilterKey(key) {
    key = String(key || '').toLowerCase();

    return (
      key.indexOf('custom.material') > -1 ||
      key.indexOf('custom.houtsoort') > -1 ||
      key.indexOf('custom.acrylsoort') > -1 ||
      key.indexOf('material') > -1 ||
      key.indexOf('hout') > -1 ||
      key.indexOf('acryl') > -1
    );
  }

  function isServingBoardUrl(url) {
    var path = '';

    try {
      path = new URL(url, window.location.origin).pathname.toLowerCase();
    } catch (e) {
      path = String(url || '').toLowerCase();
    }

    return (
      path.indexOf('serveerplank') > -1 ||
      path.indexOf('borrelplank') > -1 ||
      path.indexOf('snijplank') > -1 ||
      path.indexOf('serving-board') > -1 ||
      path.indexOf('servingboard') > -1 ||
      path.indexOf('board') > -1 ||
      path.indexOf('plank') > -1
    );
  }

  function loadCityIndex() {
    if (window.WWCCityIndex && window.WWCCityIndex.length) {
      cityIndex = window.WWCCityIndex;
      cityIndexLoaded = true;
      return Promise.resolve(cityIndex);
    }

    if (cityIndexLoaded) return Promise.resolve(cityIndex);
    if (cityIndexPromise) return cityIndexPromise;

    cityIndexPromise = fetch(section.dataset.cityIndexUrl, { credentials: 'same-origin' })
      .then(function (response) {
        return response.text();
      })
      .then(function (text) {
        var json = JSON.parse(text);
        cityIndex = Array.isArray(json.items) ? json.items : [];
        window.WWCCityIndex = cityIndex;
        cityIndexLoaded = true;
        return cityIndex;
      })
      .catch(function (error) {
        console.warn('WWC city index failed:', error);
        cityIndex = [];
        cityIndexLoaded = false;
        return cityIndex;
      });

    return cityIndexPromise;
  }

  function isCollectionUrl(url) {
    try {
      var parsed = new URL(url, window.location.origin);
      return parsed.origin === window.location.origin && /(^|\/)collections\//.test(parsed.pathname);
    } catch (e) {
      return false;
    }
  }

  function stripPageParam(url) {
    var parsed = new URL(url, window.location.origin);
    parsed.searchParams.delete('page');
    return parsed.pathname + (parsed.search ? parsed.search : '');
  }

  function getCurrentUrl() {
    return new URL(window.location.href);
  }

  function getActiveContext() {
    var url = getCurrentUrl();

    return {
      land: normalize(url.searchParams.get('filter.p.m.custom.land')),
      provincie: normalize(url.searchParams.get('filter.p.m.custom.provincie')),
      stad: normalize(url.searchParams.get('filter.p.m.custom.stad'))
    };
  }

  function cityName(item) {
    return item.plaats || item.title || '';
  }

  function cityProvince(item) {
    return item.provincie || '';
  }

  function cityCountry(item) {
    return item.country || '';
  }

  function citySub(item) {
    return [cityCountry(item), cityProvince(item)].filter(Boolean).join(' · ');
  }

  function saveRecentCity(city) {
    if (!city) return;

    try {
      var list = JSON.parse(localStorage.getItem('wwc_recent_cities') || '[]');
      list = [city].concat(list.filter(function (item) {
        return item !== city;
      })).slice(0, 5);

      localStorage.setItem('wwc_recent_cities', JSON.stringify(list));
    } catch (e) {}
  }

  function getFilterIndex() {
    var script = qs('[data-wwc-filter-index]', section);

    try {
      return JSON.parse(script ? script.textContent : '[]');
    } catch (e) {
      return [];
    }
  }

  function filterEntryByParamAndLabel(paramPart, label) {
    var wanted = normalize(label);
    if (!wanted) return null;

    var matches = getFilterIndex().filter(function (entry) {
      if (!entry || !entry.url) return false;

      try {
        var url = new URL(entry.url, window.location.origin);
        var hasParam = false;

        url.searchParams.forEach(function (value, key) {
          if (key.indexOf(paramPart) > -1) hasParam = true;
        });

        return hasParam && normalize(entry.label) === wanted;
      } catch (e) {
        return false;
      }
    });

    return matches.length ? matches[0] : null;
  }

  function mergedFilterUrlFromEntry(entry, clearKeys) {
    if (!entry || !entry.url) return null;

    var current = new URL(window.location.href);
    var target = new URL(section.dataset.collectionUrl, window.location.origin);
    var entryUrl = new URL(entry.url, window.location.origin);

    current.searchParams.forEach(function (value, key) {
      if (key === 'page') return;

      if (clearKeys.some(function (clearKey) {
        return key.indexOf(clearKey) > -1;
      })) return;

      target.searchParams.append(key, value);
    });

    entryUrl.searchParams.forEach(function (value, key) {
      if (key !== 'page') target.searchParams.set(key, value);
    });

    return target.pathname + (target.search ? target.search : '');
  }

  function cityFilterUrl(item) {
    var stad = cityName(item);
    var realCityEntry = filterEntryByParamAndLabel('custom.stad', stad);

    if (realCityEntry) {
      return mergedFilterUrlFromEntry(realCityEntry, ['custom.stad', 'custom.provincie', 'custom.land']);
    }

    var url = new URL(section.dataset.collectionUrl, window.location.origin);
    var current = getCurrentUrl();

    current.searchParams.forEach(function (value, key) {
      if (
        key !== 'filter.p.m.custom.stad' &&
        key !== 'filter.p.m.custom.provincie' &&
        key !== 'filter.p.m.custom.land' &&
        key !== 'page'
      ) {
        url.searchParams.append(key, value);
      }
    });

    var provincie = cityProvince(item);
    var land = cityCountry(item);

    if (stad) url.searchParams.set('filter.p.m.custom.stad', stad);
    if (provincie) url.searchParams.set('filter.p.m.custom.provincie', provincie);
    if (land) url.searchParams.set('filter.p.m.custom.land', land);

    return url.pathname + (url.search ? url.search : '');
  }

  function cityScore(item, query) {
    var q = normalize(query);
    if (!q) return 0;

    var name = normalize(cityName(item));
    var province = normalize(cityProvince(item));
    var country = normalize(cityCountry(item));

    if (name === q) return 100;
    if (name.indexOf(q) === 0) return 90;
    if (name.indexOf(q) > -1) return 75;
    if (province.indexOf(q) > -1) return 45;
    if (country.indexOf(q) > -1) return 35;

    return 0;
  }

  function getCityMatches(query, limit) {
    return cityIndex
      .map(function (item) {
        return { item: item, score: cityScore(item, query) };
      })
      .filter(function (entry) {
        return entry.score > 0;
      })
      .sort(function (a, b) {
        if (a.score !== b.score) return b.score - a.score;
        return normalize(cityName(a.item)).localeCompare(normalize(cityName(b.item)), 'nl');
      })
      .slice(0, limit || 8)
      .map(function (entry) {
        return entry.item;
      });
  }

  function getContextCities(query, limit) {
    var context = getActiveContext();
    var q = normalize(query);

    var list = cityIndex.filter(function (item) {
      var land = normalize(cityCountry(item));
      var provincie = normalize(cityProvince(item));
      var stad = normalize(cityName(item));

      if (context.land && land !== context.land) return false;
      if (context.provincie && provincie !== context.provincie) return false;

      if (q) {
        return stad.indexOf(q) > -1 || provincie.indexOf(q) > -1 || land.indexOf(q) > -1;
      }

      return true;
    });

    list.sort(function (a, b) {
      var aActive = normalize(cityName(a)) === context.stad ? 1 : 0;
      var bActive = normalize(cityName(b)) === context.stad ? 1 : 0;

      if (aActive !== bActive) return bActive - aActive;

      return normalize(cityName(a)).localeCompare(normalize(cityName(b)), 'nl');
    });

    return list.slice(0, limit || 40);
  }

  function getMatches(query) {
    var q = normalize(query);
    if (!q) return [];

    var cityMatches = getCityMatches(query, 8).map(function (item) {
      return {
        type: 'city',
        label: cityName(item),
        sub: citySub(item),
        url: cityFilterUrl(item),
        score: cityScore(item, query) + 100
      };
    });

    var filterMatches = getFilterIndex()
      .filter(function (item) {
        var filterName = normalize(item.filter);

        if (
          filterName.indexOf('gelegenheid') > -1 ||
          filterName.indexOf('occasion') > -1 ||
          filterName.indexOf('anlass') > -1
        ) return false;

        return normalize(item.label).indexOf(q) > -1 || filterName.indexOf(q) > -1;
      })
      .map(function (item) {
        return {
          type: 'filter',
          label: item.label,
          sub: item.filter,
          url: item.url,
          score: Number(item.count || 0)
        };
      });

    return cityMatches
      .concat(filterMatches)
      .sort(function (a, b) {
        return b.score - a.score;
      })
      .slice(0, 8);
  }

  function replace(selector, doc) {
    var oldEl = qs(selector, section);
    var newEl = qs(selector, doc);

    if (oldEl && newEl) oldEl.replaceWith(newEl);
  }

  function reInitManualBubbles() {
    document.dispatchEvent(new CustomEvent('wwc:collection:updated'));

    if (window.WWCManualCityBubblesInit) {
      window.WWCManualCityBubblesInit(document);
    }
  }

  function ajaxReplace(url, push, keepDrawerOpen) {
    if (!isCollectionUrl(url) || ajaxLock) return;

    var currentTypeTrack = qs('.wwc-visual-type-filter__track', section);
    var previousTypeScroll = currentTypeTrack ? currentTypeTrack.scrollLeft : 0;

    ajaxLock = true;
    section.classList.add('wwc-is-loading');

    fetch(url, { credentials: 'same-origin' })
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');

        replace('[data-wwc-tools]', doc);
        replace('[data-wwc-filter-drawer]', doc);
        replace('[data-wwc-filter-index]', doc);
        replace('[data-wwc-collection-labels]', doc);
        replace('#CollectionAjaxContent', doc);

        if (push) history.pushState({}, '', stripPageParam(url));

        bindAll();
        sortFilterOptions();
        renderCityPickerResults('');
        renderLocationPickers();
        restoreProductTypeSlider(previousTypeScroll);
        enhanceProductCards(section);
        reInitManualBubbles();
        preserveFiltersOnProductLinks();
        reInitTheme();

        if (keepDrawerOpen) openFilters();
      })
      .catch(function () {
        window.location.href = url;
      })
      .finally(function () {
        ajaxLock = false;
        section.classList.remove('wwc-is-loading');
      });
  }

  function appendNextPage(url, button) {
    if (!url || ajaxLock) return;

    ajaxLock = true;
    button.disabled = true;
    button.textContent = loadingText;

    fetch(url, { credentials: 'same-origin' })
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var currentGrid = qs('[data-wwc-grid-shell]', section);
        var nextGrid = qs('[data-wwc-grid-shell]', doc);
        var nextButton = qs('[data-wwc-load-more]', doc);

        if (!currentGrid || !nextGrid) {
          window.location.href = url;
          return;
        }

        var currentItems = qsa('.grid-product,.grid__item,[data-product-grid-item],.collection-grid__item', currentGrid);
        var nextItems = qsa('.grid-product,.grid__item,[data-product-grid-item],.collection-grid__item', nextGrid);

        if (currentItems.length && nextItems.length) {
          var parent = currentItems[0].parentNode;
          nextItems.forEach(function (item) {
            parent.appendChild(item);
          });
        } else {
          currentGrid.insertAdjacentHTML('beforeend', nextGrid.innerHTML);
        }

        if (nextButton) {
          button.dataset.nextUrl = nextButton.dataset.nextUrl;
          button.disabled = false;
          button.textContent = loadMoreText;
        } else {
          var wrap = button.closest('.wwc-load-more-wrap');
          if (wrap) wrap.remove();
        }

        history.replaceState({}, '', stripPageParam(url));
        enhanceProductCards(section);
        reInitManualBubbles();
        preserveFiltersOnProductLinks();
        reInitTheme();
      })
      .catch(function () {
        window.location.href = url;
      })
      .finally(function () {
        ajaxLock = false;
      });
  }

  function renderSuggestions() {
    var input = qs('[data-wwc-search]', section);
    var box = qs('[data-wwc-suggestions]', section);
    var help = qs('[data-wwc-suggestion-help]', section);
    var empty = qs('[data-wwc-suggestion-empty]', section);

    if (!input || !box) return;

    var query = input.value.trim();

    if (!query) {
      box.hidden = true;
      box.innerHTML = '';
      if (help) help.hidden = true;
      if (empty) empty.hidden = true;
      return;
    }

    loadCityIndex().then(function () {
      var matches = getMatches(query);

      if (!matches.length) {
        box.hidden = true;
        box.innerHTML = '';
        if (help) help.hidden = true;
        if (empty) empty.hidden = false;
        return;
      }

      box.innerHTML = matches.map(function (item) {
        return '<a class="wwc-suggestion" href="' + escapeHtml(item.url) + '" data-wwc-ajax-link><span>' + escapeHtml(item.label) + '</span><small>' + escapeHtml(item.sub || '') + '</small></a>';
      }).join('');

      box.hidden = false;
      if (help) help.hidden = false;
      if (empty) empty.hidden = true;
    });
  }

  function renderCityPickerResults(query) {
    var box = qs('[data-wwc-city-picker-results]', section);
    var empty = qs('[data-wwc-city-picker-empty]', section);

    if (!box) return;

    loadCityIndex().then(function () {
      var q = String(query || '').trim();
      var context = getActiveContext();
      var matches = q.length ? getContextCities(q, 40) : getContextCities('', 40);

      if (!matches.length) {
        box.innerHTML = '';
        if (empty) empty.hidden = false;
        return;
      }

      box.innerHTML = matches.map(function (item) {
        var title = cityName(item);
        var sub = citySub(item);
        var isActive = normalize(title) === context.stad;

        return '<button type="button" class="wwc-city-result' + (isActive ? ' is-active' : '') + '" data-wwc-city-name="' + escapeHtml(title) + '" data-wwc-city-url="' + escapeHtml(cityFilterUrl(item)) + '"><span class="wwc-city-radio" aria-hidden="true"></span><div><strong>' + escapeHtml(title) + '</strong><span>' + escapeHtml(sub) + '</span></div></button>';
      }).join('');

      if (empty) empty.hidden = true;
    });
  }

  function openFilters() {
    var drawer = qs('[data-wwc-filter-drawer]', section);
    if (!drawer) return;

    drawer.hidden = false;
    document.documentElement.style.overflow = 'hidden';

    sortFilterOptions();
    renderCityPickerResults('');
    renderLocationPickers();

    setTimeout(function () {
      var cityInput = qs('[data-wwc-city-picker-input]', section);
      if (cityInput) cityInput.focus();
    }, 80);
  }

  function closeFilters() {
    var drawer = qs('[data-wwc-filter-drawer]', section);
    if (!drawer) return;

    drawer.hidden = true;
    document.documentElement.style.overflow = '';
  }

  function buildFilterUrl(form, changedInput) {
    var params = new URLSearchParams();
    var current = getCurrentUrl();

    var changedName = changedInput && changedInput.name ? changedInput.name : '';
    var changedValue = changedInput && changedInput.value ? changedInput.value : '';

    var isLandChange = changedName === 'filter.p.m.custom.land';
    var isProvinceChange = changedName === 'filter.p.m.custom.provincie';
    var isChangedUnchecked = changedInput && changedInput.checked === false;

    qsa('input,select', form).forEach(function (el) {
      if (!el.name || el.disabled) return;
      if ((el.type === 'checkbox' || el.type === 'radio') && !el.checked) return;
      if (el.value === '' || el.value === null) return;

      if (isLandChange && (
        el.name === 'filter.p.m.custom.stad' ||
        el.name === 'filter.p.m.custom.provincie' ||
        el.name === 'filter.p.m.custom.land'
      )) return;

      if (isProvinceChange && (
        el.name === 'filter.p.m.custom.stad' ||
        el.name === 'filter.p.m.custom.provincie'
      )) return;

      params.append(el.name, el.value);
    });

    if (isLandChange && changedValue && !isChangedUnchecked) {
      params.set('filter.p.m.custom.land', changedValue);
    }

    if (isProvinceChange && changedValue && !isChangedUnchecked) {
      var activeLand = current.searchParams.get('filter.p.m.custom.land');
      if (activeLand) params.set('filter.p.m.custom.land', activeLand);
      params.set('filter.p.m.custom.provincie', changedValue);
    }

    if (!isLandChange && !isProvinceChange) {
      ['filter.p.m.custom.stad', 'filter.p.m.custom.provincie', 'filter.p.m.custom.land'].forEach(function (key) {
        if (!params.has(key) && current.searchParams.has(key)) {
          current.searchParams.getAll(key).forEach(function (value) {
            params.append(key, value);
          });
        }
      });
    }

    if (section.dataset.wwcMode === 'city' && current.searchParams.has(productTypeFilterKey)) {
      params.set(productTypeFilterKey, current.searchParams.get(productTypeFilterKey));
    }

    var sort = qs('[data-wwc-sort]', section);
    if (sort && sort.value) params.set('sort_by', sort.value);

    params.delete('page');

    var query = params.toString();
    return window.location.pathname + (query ? '?' + query : '');
  }

  function scheduleFilterRefresh(form, changedInput) {
    clearTimeout(ajaxTimer);

    ajaxTimer = setTimeout(function () {
      ajaxReplace(buildFilterUrl(form, changedInput), true, true);
    }, 250);
  }

  function resetFiltersKeepDrawer() {
    var url = new URL(section.dataset.collectionUrl, window.location.origin);
    var sort = qs('[data-wwc-sort]', section);

    if (sort && sort.value) {
      url.searchParams.set('sort_by', sort.value);
    }

    ajaxReplace(url.pathname + (url.search ? url.search : ''), true, true);
  }

  function filterDrawerOptions(input) {
    var group = input.closest('[data-wwc-filter-group]');
    if (!group) return;

    var q = normalize(input.value);
    var visible = 0;

    qsa('[data-wwc-option]', group).forEach(function (option) {
      var match = !q || normalize(option.textContent).indexOf(q) > -1;
      option.style.display = match ? '' : 'none';
      if (match) visible += 1;
    });

    var empty = qs('.wwc-sidebar-filter-empty', group);
    if (empty) empty.hidden = visible > 0;
  }

  function sortFilterOptions() {
    qsa('[data-wwc-filter-options]', section).forEach(function (list) {
      var options = qsa('[data-wwc-option]', list);

      options.sort(function (a, b) {
        var aa = Number(a.dataset.active || 0);
        var ba = Number(b.dataset.active || 0);

        if (aa !== ba) return ba - aa;

        return Number(b.dataset.count || 0) - Number(a.dataset.count || 0);
      });

      options.forEach(function (option) {
        list.appendChild(option);
      });
    });
  }

  function runSearch() {
    var input = qs('[data-wwc-search]', section);
    var query = input ? input.value.trim() : '';

    if (!query) return;

    loadCityIndex().then(function () {
      var matches = getMatches(query);

      if (matches.length) {
        ajaxReplace(matches[0].url, true, false);
        return;
      }

      /* De index is hierboven al geraadpleegd en zei: deze plaats bestaat niet.

         Die uitkomst ging tot 31 augustus 2026 verloren op de doorverwijzing.
         De zoekpagina begon dan blanco en Shopify antwoordde met een andere stad
         - "Denekamp" leverde Skyline Kampen op. De zoekpagina zoekt het nu zelf
         opnieuw uit, dus dit signaal is geen voorwaarde meer; het maakt in de
         meting alleen zichtbaar dat iemand langs deze route binnenkwam. */
      var searchUrl = section.dataset.searchUrl || '/search';
      window.location.href = searchUrl + '?q=' + encodeURIComponent(query) + '&wwc_bron=plaatszoek';
    });
  }

  function uniqueLocations(type) {
    var map = {};

    cityIndex.forEach(function (item) {
      var country = cityCountry(item);
      var province = cityProvince(item);

      if (type === 'country' && country) {
        var countryKey = normalize(country);

        if (!map[countryKey]) {
          map[countryKey] = { label: country, sub: '', count: 0 };
        }

        map[countryKey].count += 1;
      }

      if (type === 'province' && country && province) {
        var provinceKey = normalize(country) + '|' + normalize(province);

        if (!map[provinceKey]) {
          map[provinceKey] = { label: province, country: country, sub: country, count: 0 };
        }

        map[provinceKey].count += 1;
      }
    });

    return Object.keys(map).map(function (key) {
      return map[key];
    });
  }

  function countryFilterUrl(country) {
    var realCountryEntry = filterEntryByParamAndLabel('custom.land', country);

    if (realCountryEntry) {
      return mergedFilterUrlFromEntry(realCountryEntry, ['custom.stad', 'custom.provincie', 'custom.land']);
    }

    var url = new URL(section.dataset.collectionUrl, window.location.origin);
    var current = getCurrentUrl();

    current.searchParams.forEach(function (value, key) {
      if (
        key !== 'filter.p.m.custom.stad' &&
        key !== 'filter.p.m.custom.provincie' &&
        key !== 'filter.p.m.custom.land' &&
        key !== 'page'
      ) {
        url.searchParams.append(key, value);
      }
    });

    url.searchParams.set('filter.p.m.custom.land', country);

    return url.pathname + (url.search ? url.search : '');
  }

  function provinceFilterUrl(province, country) {
    var realProvinceEntry = filterEntryByParamAndLabel('custom.provincie', province);

    if (realProvinceEntry) {
      return mergedFilterUrlFromEntry(realProvinceEntry, ['custom.stad', 'custom.provincie']);
    }

    var url = new URL(section.dataset.collectionUrl, window.location.origin);
    var current = getCurrentUrl();

    current.searchParams.forEach(function (value, key) {
      if (
        key !== 'filter.p.m.custom.stad' &&
        key !== 'filter.p.m.custom.provincie' &&
        key !== 'filter.p.m.custom.land' &&
        key !== 'page'
      ) {
        url.searchParams.append(key, value);
      }
    });

    if (country) url.searchParams.set('filter.p.m.custom.land', country);
    url.searchParams.set('filter.p.m.custom.provincie', province);

    return url.pathname + (url.search ? url.search : '');
  }

  function renderCountryPickerResults(query) {
    var box = qs('[data-wwc-country-picker-results]', section);
    if (!box) return;

    loadCityIndex().then(function () {
      var context = getActiveContext();
      var q = normalize(query);

      var items = uniqueLocations('country').filter(function (item) {
        return !q || normalize(item.label).indexOf(q) > -1;
      });

      items.sort(function (a, b) {
        var aActive = normalize(a.label) === context.land ? 1 : 0;
        var bActive = normalize(b.label) === context.land ? 1 : 0;

        if (aActive !== bActive) return bActive - aActive;
        if (q) return normalize(a.label).localeCompare(normalize(b.label), 'nl');
        if (a.count !== b.count) return b.count - a.count;

        return normalize(a.label).localeCompare(normalize(b.label), 'nl');
      });

      box.innerHTML = items.map(function (item) {
        var isActive = normalize(item.label) === context.land;

        return '<button type="button" class="wwc-location-result' + (isActive ? ' is-active' : '') + '" data-wwc-country-url="' + escapeHtml(countryFilterUrl(item.label)) + '"><span class="wwc-location-radio" aria-hidden="true"></span><div><strong>' + escapeHtml(item.label) + '</strong><span>' + item.count + '</span></div></button>';
      }).join('');
    });
  }

  function renderProvincePickerResults(query) {
    var box = qs('[data-wwc-province-picker-results]', section);
    if (!box) return;

    loadCityIndex().then(function () {
      var context = getActiveContext();
      var q = normalize(query);

      var items = uniqueLocations('province').filter(function (item) {
        if (context.land && normalize(item.country) !== context.land) return false;
        return !q || normalize(item.label).indexOf(q) > -1;
      });

      items.sort(function (a, b) {
        var aActive = normalize(a.label) === context.provincie ? 1 : 0;
        var bActive = normalize(b.label) === context.provincie ? 1 : 0;

        if (aActive !== bActive) return bActive - aActive;
        if (q) return normalize(a.label).localeCompare(normalize(b.label), 'nl');
        if (a.count !== b.count) return b.count - a.count;

        return normalize(a.label).localeCompare(normalize(b.label), 'nl');
      });

      box.innerHTML = items.map(function (item) {
        var isActive = normalize(item.label) === context.provincie;

        return '<button type="button" class="wwc-location-result' + (isActive ? ' is-active' : '') + '" data-wwc-province-url="' + escapeHtml(provinceFilterUrl(item.label, item.country)) + '"><span class="wwc-location-radio" aria-hidden="true"></span><div><strong>' + escapeHtml(item.label) + '</strong><span>' + escapeHtml(item.sub || '') + ' · ' + item.count + '</span></div></button>';
      }).join('');
    });
  }

  function renderLocationPickers() {
    renderCountryPickerResults('');
    renderProvincePickerResults('');
  }

  function preserveFiltersOnProductLinks() {
    var selectors = [
  '[data-wwc-product-route-link]',

    /* Oude Manual City Bubbles */
    '.wwc-manual-bubbles__image-link[href*="/collections/"]',
    '.wwc-manual-bubbles__title-link[href*="/collections/"]',
    '.wwc-manual-bubbles__lastcard[href*="/collections/"]',

    /* Nieuwe Manual City Bubbles */
    '[data-wwc-manual-bubbles] a[href*="/collections/"]',
    '.wwc-manual-city-bubbles a[href*="/collections/"]',
    '.wwc-bubbles__image-link[href*="/collections/"]',
    '.wwc-bubbles__title-link[href*="/collections/"]'
  ].join(',');

    var current = new URL(window.location.href);
    current.searchParams.delete('page');

    var hasActiveParams = current.searchParams.toString() !== '';

    qsa(selectors, document).forEach(function (link) {
      var rawHref = link.getAttribute('href');
      if (!rawHref || rawHref.indexOf('/collections/') === -1) return;

      if (!link.dataset.wwcBaseHref) {
        var original = new URL(rawHref, window.location.origin);
        original.searchParams.delete('page');
        link.dataset.wwcBaseHref = original.pathname;
      }

      var baseHref = link.dataset.wwcBaseHref;
      var url = new URL(baseHref, window.location.origin);

      if (!hasActiveParams) {
        link.href = url.pathname;
        return;
      }

      current.searchParams.forEach(function (value, key) {
        if (key === 'page') return;

        if (isServingBoardUrl(url.href) && isMaterialFilterKey(key)) {
          return;
        }

        url.searchParams.append(key, value);
      });

      link.href = url.pathname + (url.search ? url.search : '');
    });
  }

  function productTypeFilterUrl(value) {
    var url = new URL(window.location.href);

    url.searchParams.delete('page');
    url.searchParams.delete(productTypeFilterKey);

    if (value) {
      url.searchParams.set(productTypeFilterKey, value);
    }

    return url.pathname + (url.search ? url.search : '');
  }

  function enforceSingleProductTypeInDrawer(changedInput) {
    if (!changedInput || changedInput.name !== productTypeFilterKey) return;

    var form = qs('[data-wwc-filter-form]', section);
    if (!form) return;

    qsa('input[name="' + productTypeFilterKey + '"]', form).forEach(function (input) {
      if (input !== changedInput) input.checked = false;
    });
  }

  function clearMaterialFilterUrl() {
    var url = new URL(window.location.href);
    var materialKeys = [];

    url.searchParams.forEach(function (value, key) {
      if (isMaterialFilterKey(key)) {
        materialKeys.push(key);
      }
    });

    materialKeys.forEach(function (key) {
      url.searchParams.delete(key);
    });

    url.searchParams.delete('page');

    return url.pathname + (url.search ? url.search : '');
  }

  function setActiveProductTypeChips() {
    var url = new URL(window.location.href);
    var active = normalize(url.searchParams.get(productTypeFilterKey));

    qsa('[data-wwc-product-filter]', section).forEach(function (btn) {
      var value = normalize(btn.dataset.wwcProductFilter);
      btn.classList.toggle('is-active', (!active && !value) || (active && value === active));
    });
  }

  function restoreProductTypeSlider(previousScroll) {
    var track = qs('.wwc-visual-type-filter__track', section);
    if (!track) return;

    requestAnimationFrame(function () {
      var activeCard = qs('.wwc-visual-type-card.is-active', track);

      if (scrollActiveProductTypeAfterAjax && activeCard) {
        var trackRect = track.getBoundingClientRect();
        var cardRect = activeCard.getBoundingClientRect();

        var currentLeft = track.scrollLeft;
        var cardCenter = cardRect.left - trackRect.left + currentLeft + (cardRect.width / 2);
        var targetLeft = cardCenter - (track.clientWidth / 2);

        track.scrollTo({
          left: Math.max(0, targetLeft),
          behavior: 'auto'
        });
      } else {
        track.scrollLeft = previousScroll || 0;
      }

      scrollActiveProductTypeAfterAjax = false;
    });
  }

  function bindAll() {
    preserveFiltersOnProductLinks();
    setActiveProductTypeChips();

    qsa('[data-wwc-product-filter]', section).forEach(function (btn) {
      if (btn.dataset.bound) return;

      btn.dataset.bound = '1';

      btn.addEventListener('click', function () {
        scrollActiveProductTypeAfterAjax = true;
        ajaxReplace(productTypeFilterUrl(btn.dataset.wwcProductFilter), true, false);
      });
    });

    qsa('[data-wwc-open-filters]', section).forEach(function (btn) {
      if (btn.dataset.bound) return;

      btn.dataset.bound = '1';
      btn.addEventListener('click', openFilters);
    });

    qsa('[data-wwc-close-filters]', section).forEach(function (btn) {
      if (btn.dataset.bound) return;

      btn.dataset.bound = '1';
      btn.addEventListener('click', closeFilters);
    });

    qsa('[data-wwc-reset-filters]', section).forEach(function (btn) {
      if (btn.dataset.bound) return;

      btn.dataset.bound = '1';

      btn.addEventListener('click', function (event) {
        event.preventDefault();
        resetFiltersKeepDrawer();
      });
    });

    var search = qs('[data-wwc-search]', section);

    if (search && !search.dataset.bound) {
      search.dataset.bound = '1';

      search.addEventListener('input', function () {
        var clear = qs('[data-wwc-search-clear]', section);
        if (clear) clear.hidden = !search.value.trim();
        renderSuggestions();
      });

      search.addEventListener('keydown', function (event) {
        if (event.key === 'Enter') {
          event.preventDefault();
          runSearch();
        }
      });
    }

    var searchBtn = qs('[data-wwc-search-submit]', section);

    if (searchBtn && !searchBtn.dataset.bound) {
      searchBtn.dataset.bound = '1';
      searchBtn.addEventListener('click', runSearch);
    }

    var clearBtn = qs('[data-wwc-search-clear]', section);

    if (clearBtn && !clearBtn.dataset.bound) {
      clearBtn.dataset.bound = '1';

      clearBtn.addEventListener('click', function () {
        var input = qs('[data-wwc-search]', section);
        if (!input) return;

        input.value = '';
        clearBtn.hidden = true;
        renderSuggestions();
        input.focus();
      });
    }

    var sort = qs('[data-wwc-sort]', section);

    if (sort && !sort.dataset.bound) {
      sort.dataset.bound = '1';

      sort.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sort.value);
        url.searchParams.delete('page');
        ajaxReplace(url.pathname + (url.search ? url.search : ''), true, false);
      });
    }

    var cityInput = qs('[data-wwc-city-picker-input]', section);

    if (cityInput && !cityInput.dataset.bound) {
      cityInput.dataset.bound = '1';

      cityInput.addEventListener('input', function () {
        renderCityPickerResults(cityInput.value);
      });
    }

    var form = qs('[data-wwc-filter-form]', section);

    if (form && !form.dataset.bound) {
      form.dataset.bound = '1';

      form.addEventListener('submit', function (event) {
        event.preventDefault();
        closeFilters();
        ajaxReplace(buildFilterUrl(form), true, false);
      });

      form.addEventListener('change', function (event) {
        if (event.target.matches('input[type="checkbox"],input[type="radio"]')) {
          if (section.dataset.wwcMode === 'city' && event.target.name === productTypeFilterKey) {
            enforceSingleProductTypeInDrawer(event.target);
            closeFilters();
            ajaxReplace(productTypeFilterUrl(event.target.checked ? event.target.value : ''), true, false);
            return;
          }

          enforceSingleProductTypeInDrawer(event.target);
          scheduleFilterRefresh(form, event.target);
        }
      });
    }

    qsa('[data-wwc-filter-search]', section).forEach(function (input) {
      if (input.dataset.bound) return;

      input.dataset.bound = '1';

      input.addEventListener('input', function () {
        filterDrawerOptions(input);
      });
    });

    var countryInput = qs('[data-wwc-country-picker-input]', section);

    if (countryInput && !countryInput.dataset.bound) {
      countryInput.dataset.bound = '1';

      countryInput.addEventListener('input', function () {
        renderCountryPickerResults(countryInput.value);
      });
    }

    var provinceInput = qs('[data-wwc-province-picker-input]', section);

    if (provinceInput && !provinceInput.dataset.bound) {
      provinceInput.dataset.bound = '1';

      provinceInput.addEventListener('input', function () {
        renderProvincePickerResults(provinceInput.value);
      });
    }
  }

  function reInitTheme() {
    setTimeout(function () {
      document.dispatchEvent(new CustomEvent('page:loaded'));
      document.dispatchEvent(new CustomEvent('collection:reloaded'));

      if (window.AOS && typeof window.AOS.refreshHard === 'function') {
        window.AOS.refreshHard();
      }

      if (window.theme) {
        if (window.theme.QuickShop && typeof window.theme.QuickShop.init === 'function') {
          window.theme.QuickShop.init();
        }

        if (typeof window.theme.initQuickShop === 'function') {
          window.theme.initQuickShop();
        }

        if (window.theme.ProductGrid && typeof window.theme.ProductGrid.init === 'function') {
          window.theme.ProductGrid.init();
        }
      }
    }, 120);
  }

  section.addEventListener('click', function (event) {
    var country = event.target.closest('[data-wwc-country-url]');

    if (country) {
      event.preventDefault();
      ajaxReplace(country.dataset.wwcCountryUrl, true, true);
      return;
    }

    var province = event.target.closest('[data-wwc-province-url]');

    if (province) {
      event.preventDefault();
      ajaxReplace(province.dataset.wwcProvinceUrl, true, true);
      return;
    }

    var city = event.target.closest('[data-wwc-city-url]');

    if (city) {
      event.preventDefault();

      if (city.dataset.wwcCityName) {
        saveRecentCity(city.dataset.wwcCityName);
      }

      ajaxReplace(city.dataset.wwcCityUrl, true, true);
      return;
    }

    var link = event.target.closest('[data-wwc-ajax-link]');

    if (link) {
      event.preventDefault();
      closeFilters();
      ajaxReplace(link.href, true, false);
      return;
    }

    var clearMaterial = event.target.closest('[data-wwc-clear-material-filter]');

    if (clearMaterial) {
      event.preventDefault();
      ajaxReplace(clearMaterialFilterUrl(), true, false);
      return;
    }

    var more = event.target.closest('[data-wwc-load-more]');

    if (more) {
      event.preventDefault();
      appendNextPage(more.dataset.nextUrl, more);
    }
  });

  window.addEventListener('popstate', function () {
    ajaxReplace(window.location.href, false, false);
  });

  /* ==================================================
     WWC Collection - Product Card Meta
  ================================================== */

  function getCollectionLabels() {
    var labelsEl = section.querySelector('[data-wwc-collection-labels]');

    try {
      return JSON.parse(labelsEl ? labelsEl.textContent : '{}');
    } catch (e) {
      return {};
    }
  }

  function getTitleElement(card) {
    return card.querySelector('.grid-product__title, .grid-product__title--body, .product-card__title, .card__heading');
  }

  function getPriceElement(card) {
    return card.querySelector('.grid-product__price, .product-card__price, .price');
  }

  function detectMaterialFromText(value) {
    var text = normalize(value);

    var list = [
      {
        words: ['zwart glanzend', 'glossy black', 'glänzend schwarz', 'glanzend schwarz', 'noir brillant'],
        label: 'Zwart Glanzend',
        cls: 'zwart-glanzend'
      },
      {
        words: ['wit glanzend', 'glossy white', 'glänzend weiss', 'glanzend weiss', 'glänzend weiß', 'glanzend weiß', 'blanc brillant'],
        label: 'Wit Glanzend',
        cls: 'wit-glanzend'
      },
      {
        words: ['goud metallic', 'metallic gold', 'gold metallic', 'doré métallisé', 'dore metallise'],
        label: 'Goud Metallic',
        cls: 'goud-metallic'
      },
      {
        words: ['spiegel', 'mirror', 'miroir'],
        label: 'Spiegel',
        cls: 'spiegel'
      },
      {
        words: ['palissander', 'rosewood', 'palisander', 'palissandre'],
        label: 'Palissander',
        cls: 'palissander'
      },
      {
        words: ['bamboe', 'bamboo', 'bambus', 'bambou'],
        label: 'Bamboe',
        cls: 'bamboe'
      },
      {
        words: ['beuken', 'beech', 'buche', 'hêtre', 'hetre'],
        label: 'Beuken',
        cls: 'beuken'
      },
      {
        words: ['eiken', 'oak', 'eiche', 'chêne', 'chene'],
        label: 'Eiken',
        cls: 'eiken'
      },
      {
        words: ['noten', 'walnoot', 'walnut', 'nussbaum', 'noyer'],
        label: 'Noten',
        cls: 'noten'
      },
      {
        words: ['zwart', 'black', 'schwarz', 'noir'],
        label: 'Zwart',
        cls: 'zwart'
      }
    ];

    for (var i = 0; i < list.length; i += 1) {
      for (var j = 0; j < list[i].words.length; j += 1) {
        if (text.indexOf(normalize(list[i].words[j])) > -1) {
          return list[i];
        }
      }
    }

    return null;
  }

  function detectMaterial(card, title) {
    var fromData = card ? card.getAttribute('data-wwc-material') : '';

    if (fromData) {
      var materialFromData = detectMaterialFromText(fromData);
      if (materialFromData) return materialFromData;
    }

    return detectMaterialFromText(title);
  }

  function cleanTitle(title, material) {
    var clean = String(title || '');

    if (!material || !material.words) return clean.trim();

    material.words.forEach(function (word) {
      var escaped = word.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      clean = clean.replace(new RegExp('\\s*\\b' + escaped + '\\b\\s*', 'ig'), ' ');
    });

    return clean.replace(/\s+/g, ' ').trim();
  }

  // "40-60 cm" las als een bereik, alsof je elke maat daartussen kon kiezen.
  // Het zijn losse maten: 40 of 60. Vandaar opsommen in plaats van een streepje.
  // Het voegwoord volgt de taal van de pagina; de maten zelf zijn overal gelijk.
  function maatVoegwoord() {
    var taal = (document.documentElement.lang || 'nl').slice(0, 2).toLowerCase();
    return { nl: ' of ', en: ' or ', de: ' oder ', fr: ' ou ' }[taal] || ' of ';
  }

  function maatReeks(maten) {
    var v = maatVoegwoord();
    if (maten.length === 1) return maten[0] + ' cm';
    return maten.slice(0, -1).join(', ') + v + maten[maten.length - 1] + ' cm';
  }

  function detectSizes(title) {
    var text = normalize(title);

    if (text.indexOf('klok') > -1 && text.indexOf('rond') > -1 && text.indexOf('halfrond') === -1) return ['44 cm'];
    if (text.indexOf('klok') > -1) return ['40 cm'];
    if (text.indexOf('standing') > -1) return [maatReeks(['40', '60'])];

    if (
      text.indexOf('skyline') > -1 &&
      text.indexOf('standing') === -1 &&
      text.indexOf('klok') === -1 &&
      text.indexOf('magneet') === -1 &&
      text.indexOf('onderzetter') === -1 &&
      text.indexOf('telefoonhouder') === -1 &&
      text.indexOf('serveerplank') === -1
    ) return [maatReeks(['80', '100', '120'])];

    return [];
  }

  /* Feitenregel per productsoort, ingesteld in de theme-editor.

     Waarom op een stukje van de handle en niet op het producttype: het type is
     vertaalbaar ("Klok" wordt "Clock"), en de herkenning hieronder werkt daarom
     op titelwoorden in vier talen - met als resultaat dat op /en bij bijna elk
     product dezelfde regel verscheen. Een handle vertaalt niet, dus `klok`
     matcht in elke taal hetzelfde product.

     De tokens verwijzen naar de vertaalde labels die de sectie al meestuurt:
     de woorden blijven per taal kloppen, alleen de koppeling is instelbaar. */
  function configFacts(card) {
    var labels = getCollectionLabels();
    var regels = String(labels.typeFacts || '').split('\n');
    if (!regels.length) return null;

    var handle = (card && card.getAttribute && card.getAttribute('data-product-handle')) || '';
    handle = handle.toLowerCase();
    if (!handle) return null;

    var L = labels.pills || {};
    var terugval = null;

    for (var i = 0; i < regels.length; i++) {
      var regel = regels[i].trim();
      if (!regel || regel.charAt(0) === '#') continue;
      var deel = regel.split(':');
      if (deel.length < 2) continue;

      var sleutel = deel[0].trim().toLowerCase();
      var tokens = deel.slice(1).join(':').split(',').map(function (t) { return t.trim(); }).filter(Boolean);
      if (!tokens.length) continue;

      var uit = tokens.map(function (t) { return L[t] || t; });
      if (sleutel === '*') { if (!terugval) terugval = uit; continue; }
      if (handle.indexOf(sleutel) > -1) return uit;
    }
    return terugval;
  }

  function detectExtraPills(title) {
    var text = normalize(title);
    var pills = [];
    var labels = getCollectionLabels();
    var L = labels.pills || {};

    if (text.indexOf('standing') > -1) pills.unshift(L.standing || 'Standing');

    if (
      text.indexOf('skyline') > -1 &&
      text.indexOf('standing') === -1 &&
      text.indexOf('klok') === -1 &&
      text.indexOf('clock') === -1 &&
      text.indexOf('magneet') === -1 &&
      text.indexOf('magnet') === -1 &&
      text.indexOf('onderzetter') === -1 &&
      text.indexOf('coaster') === -1 &&
      text.indexOf('telefoonhouder') === -1 &&
      text.indexOf('phone holder') === -1 &&
      text.indexOf('serveerplank') === -1 &&
      text.indexOf('serving board') === -1
    ) pills.unshift(L.wall || 'Wall');

    if (text.indexOf('magneet') > -1 || text.indexOf('magnet') > -1) pills.push(L.fridge || 'Fridge', L.combine || 'Combine');
    if (text.indexOf('onderzetter') > -1 || text.indexOf('coaster') > -1) pills.push(L.set4 || 'Set of 4', L.table || 'Table');
    if (text.indexOf('telefoonhouder') > -1 || text.indexOf('phone holder') > -1) pills.push(L.desk || 'Desk', L.office || 'Office');

    if ((text.indexOf('serveerplank') > -1 || text.indexOf('serving board') > -1) && (text.indexOf('rond') > -1 || text.indexOf('round') > -1)) {
      pills.push(L.round || 'Round', L.drinks || 'Drinks');
    } else if (text.indexOf('serveerplank') > -1 || text.indexOf('serving board') > -1) {
      pills.push(L.rect || 'Rectangle', L.drinks || 'Drinks');
    }

    if (text.indexOf('keukenschort') > -1 || text.indexOf('schort') > -1 || text.indexOf('apron') > -1) {
      pills.push(L.kitchen || 'Kitchen', L.cooking || 'Cooking');
    }

    if (text.indexOf('tas') > -1 || text.indexOf('shopper') > -1 || text.indexOf('bag') > -1) {
      pills.push(L.shopper || 'Shopper', L.cotton || 'Cotton');
    }

    if (text.indexOf('rompertje') > -1 || text.indexOf('romper') > -1) {
      pills.push(L.sizes4 || '4 sizes', L.colors4 || '4 colors');
    }

    if (text.indexOf('hoodie') > -1 || text.indexOf('t-shirt') > -1 || text.indexOf('shirt') > -1) {
      pills.push(L.sizes5 || '5 sizes', L.colors7 || '7 colors');
    }

    return pills;
  }

  function enhanceProductCards(root) {
    var scope = root || document;
    var cards = scope.querySelectorAll('.grid-product, .grid__item, [data-product-grid-item], .collection-grid__item');

    cards.forEach(function (card) {
      if (card.dataset.wwcProductMetaDone === '1') return;

      var titleEl = getTitleElement(card);
      var priceEl = getPriceElement(card);

      if (!titleEl) return;

      var originalTitle = titleEl.textContent.trim();
      if (!originalTitle) return;

      var material = detectMaterial(card, originalTitle);

      /* De producthandle meesturen als zoektekst, niet alleen de titel.
      
         detectSizes en detectExtraPills herkennen producten aan Nederlandse
         woorden in de titel ('klok', 'onderzetter', 'serveerplank'). Op /en
         heten die producten Clock, Coasters en Serving Board, dus die tests
         faalden allemaal — en dan viel élk product met 'skyline' in de naam in
         de laatste tak: de wandskyline. Gemeten op /en/collections/skyline-utrecht
         stond daardoor "80, 100 or 120 cm" op de onderzetters, de magneet, de
         klok én de telefoonhouder.
      
         De handle vertaalt niet: de Engelse klok heet nog steeds
         skyline-klok-utrecht. Door hem voor de titel te plakken werken alle
         bestaande tests in elke taal, ook in Duits en Frans waar nooit aliassen
         voor zijn gemaakt. De titel blijft erbij, zodat niets wat al werkte
         stukgaat.
      
         Let op: alleen voor het herkennen. detectMaterial en cleanTitle krijgen
         de echte titel, want die bewerken de tekst die de bezoeker leest. */
      var handleWoorden = String(card.getAttribute('data-product-handle') || '').replace(/-/g, ' ');
      var zoekTekst = handleWoorden + ' ' + originalTitle;

      var sizes = detectSizes(zoekTekst);
      // Eerst de ingestelde koppeling; die is taalvast. Alleen als daar geen
      // regel op past, terugvallen op de oude herkenning op titelwoorden.
      var uitConfig = configFacts(card);
      var extraPills = uitConfig || detectExtraPills(zoekTekst);

      /* Staat de maat in de koppeling, dan is die leidend.

         De maat uit de titel werd er los bij gezet, en sinds de koppeling zelf
         een maat meegeeft stond er twee keer hetzelfde: "40 × 27 cm · 40 cm".
         De ingestelde maat is bovendien de nauwkeurigste - hij noemt beide
         zijden waar de titel alleen de lengte kende. */
      if (uitConfig && sizes.length) {
        var heeftMaat = uitConfig.some(function (t) { return /\d/.test(t); });
        if (heeftMaat) sizes = [];
      }
      var clean = cleanTitle(originalTitle, material);

      if (clean && clean !== originalTitle) {
        titleEl.textContent = clean;
      }

      if (material || sizes.length || extraPills.length) {
        var meta = document.createElement('div');
        meta.className = 'wwc-product-card-meta';

        extraPills.forEach(function (label) {
          meta.insertAdjacentHTML('beforeend', '<span class="wwc-product-pill wwc-product-pill--extra">' + escapeHtml(label) + '</span>');
        });

        sizes.forEach(function (size) {
          meta.insertAdjacentHTML('beforeend', '<span class="wwc-product-pill wwc-product-pill--size">' + escapeHtml(size) + '</span>');
        });

        if (material) {
          /* Pas hier vertalen, niet eerder.

             De materiaalnaam komt uit de productdata en staat daar in het
             Nederlands; op /en las de kaart "Serving board · 36.5 × 20 cm ·
             Beuken". Maar dezelfde waarde wordt ook gebruikt om de houtsoort
             uit de producttitel te strippen (cleanTitle) en om de kleurklasse
             te bepalen. Vertaal je hem daarvóór, dan matcht dat strippen niet
             meer. Alleen het zichtbare label gaat door de tabel; is er geen
             vertaling, dan blijft het bronwoord staan. */
          var matTabel = (getCollectionLabels().materialNames) || {};
          var matLabel = matTabel[material.label] || material.label;
          meta.insertAdjacentHTML('beforeend', '<span class="wwc-product-pill wwc-product-pill--' + material.cls + '">' + escapeHtml(matLabel) + '</span>');
        }

        titleEl.insertAdjacentElement('afterend', meta);
      }

      if (priceEl) {
        priceEl.classList.add('wwc-card-price-tuned');
      }

      card.dataset.wwcProductMetaDone = '1';
    });

    // Sein voor wwc-collection-groups.js: de pills staan er nu pas. Zonder dit
    // wint de materiaal-groepering de race en toont de pill een ander materiaal
    // dan de foto.
    document.dispatchEvent(new CustomEvent('wwc:cards-enhanced'));
  }

  bindAll();
  sortFilterOptions();

  loadCityIndex().then(function () {
    renderCityPickerResults('');
    renderLocationPickers();
  });

  enhanceProductCards(section);

  document.addEventListener('collection:reloaded', function () {
    setTimeout(function () {
      preserveFiltersOnProductLinks();
      enhanceProductCards(section);
    }, 180);
  });

  document.addEventListener('page:loaded', function () {
    setTimeout(function () {
      preserveFiltersOnProductLinks();
      enhanceProductCards(section);
    }, 180);
  });
})();

/* =========================================================
   WWC - Steps #8
   Handles step clicks, prev/next buttons and mobile nav scroll.
========================================================= */

(function () {
  'use strict';

  function initSteps8(section) {
    if (!section || section.dataset.wwcSteps8Ready === '1') return;

    const steps = Array.from(section.querySelectorAll('[data-wwc-steps8-step]'));
    const items = Array.from(section.querySelectorAll('[data-wwc-steps8-item]'));
    const prevBtn = section.querySelector('[data-wwc-steps8-prev]');
    const nextBtn = section.querySelector('[data-wwc-steps8-next]');
    const scrollContainer = section.querySelector('[data-wwc-steps8-scroll]');

    if (!steps.length || !items.length) return;

    section.dataset.wwcSteps8Ready = '1';

    let currentIndex = Math.max(
      0,
      steps.findIndex((step) => step.classList.contains('active'))
    );

    function updateActiveStep(index) {
      currentIndex = index;

      steps.forEach((step, stepIndex) => {
        const isActive = stepIndex === currentIndex;
        step.classList.toggle('active', isActive);
        step.setAttribute('aria-current', isActive ? 'true' : 'false');
      });

      items.forEach((item, itemIndex) => {
        item.classList.toggle('active', itemIndex === currentIndex);
      });

      if (window.innerWidth < 1024 && scrollContainer && steps[currentIndex]) {
        const activeStep = steps[currentIndex];
        const targetLeft =
          activeStep.offsetLeft -
          scrollContainer.clientWidth / 2 +
          activeStep.clientWidth / 2;

        scrollContainer.scrollTo({
          left: targetLeft,
          behavior: 'smooth',
        });
      }
    }

    steps.forEach((step, index) => {
      step.addEventListener('click', () => updateActiveStep(index));
    });

    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        updateActiveStep((currentIndex + 1) % steps.length);
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        updateActiveStep((currentIndex - 1 + steps.length) % steps.length);
      });
    }
  }

  function initAllSteps8() {
    document.querySelectorAll('[data-wwc-steps8]').forEach(initSteps8);
  }

  document.addEventListener('DOMContentLoaded', initAllSteps8);

  document.addEventListener('shopify:section:load', function (event) {
    const section = event.target.querySelector('[data-wwc-steps8]');

    if (section) {
      section.dataset.wwcSteps8Ready = '';
      initSteps8(section);
    }
  });
})();